<template>
    <div>
        <table class="w-100 table b-table">
            <tr>
                <th>
                    Nombre
                </th>
                <th>
                    Número de serie
                </th>
                <th>
                    Fecha de inicio
                </th>
                <th>
                    Fecha de fin
                </th>
                <th>
                </th>
            </tr>
            <tr v-for="childrenInstallation in children_installations" :key="childrenInstallation.id">
                <td class="pt-1">
                    {{ childrenInstallation.vhe_code }}
                </td>
                <td class="pt-1">
                    {{ childrenInstallation.serial_number }}
                </td>
                <td class="pt-1">
                    {{ childrenInstallation.start_date ? helpers.formatDate(childrenInstallation.start_date) : null }}
                </td>
                <td class="pt-1">
                    {{ childrenInstallation.end_date ? helpers.formatDate(childrenInstallation.end_date) : null }}
                </td>
                <td class="pt-1">
                    <router-link :to="{ name: 'children_installations_vhe_edit', params: { id: childrenInstallation.id} }" target="_blank">
                        <b-button variant="primary">
                            Ver instalación
                        </b-button>
                    </router-link>

                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import {mapState} from "vuex"
import helpers from "@/resources/helpers/helpers"
import {createHelpers} from "vuex-map-fields"


const {mapFields} = createHelpers({
    getterType: 'childrenInstallationVhe/getField',
    mutationType: 'childrenInstallationVhe/updateField',
})

export default {
    name: "ListChildrenInstallations",
    components: {
        BButton,
    },
    data() {
        return {
            helpers
        }
    },
    computed: {
        ...mapState('childrenInstallationVhe', []),
        ...mapFields({
            children_installations: 'children_installations',
        }),
    },
    mounted() {
        this.getChildrenInstallations()
    },
    methods:{
        getChildrenInstallations() {
            this.showLoading = true

            this.$store.dispatch('childrenInstallationVhe/listChildrenInstallationsByMaster', {
                id: this.$route.params.id,
            })
                .then(response => {
                    this.childrenInstallations = response
                })
                .catch(error => {
                    this.showLoading = false
                    console.log(error)
                })
        },
    }

}
</script>

<style scoped>

</style>